/* eslint-disable */
import {
  getCounteragents,
  createCounteragent,
  updateCounteragent,
  deleteCounteragent,
} from '@/methods/counteragent';
import { ElNotification } from 'element-plus';
import { getDenyPrivilegeObject, getErrorMessage } from '@/compositions/helpers/helpers';

// Дедуп одновременных запросов списка: блок ЭТРН и постоянно смонтированные
// *FormDialog дергают getCounteragents в один тик — схлопываем их в один HTTP-запрос.
// Ключ — partnerId (или 'all' без фильтра): фильтрованный и полный список
// не должны схлопываться в один запрос.
const counteragentsInFlight = new Map();

// Список в сторе один на всё приложение, а запросы с разным фильтром летят параллельно.
// Отвечают они в произвольном порядке, поэтому применяем только ответ на последний
// запрошенный фильтр — иначе полный список затирает отфильтрованный.
let counteragentsLatestKey = null;

const state = {
  list: [],
  dataIsUpdated: false,
};

const getters = {
  getCounteragents(state) {
    return state.list;
  },
};

const mutations = {
  UPDATE_COUNTERAGENTS(state, data) {
    state.list = data;
  },
  COUNTERAGENTS_DATA_IS_UPDATED(state, data) {
    state.dataIsUpdated = data;
  },
};

const actions = {
  // payload.partnerId — партнёр брони: список сужается до его записей и «общих».
  getCounteragents({ commit }, payload = {}) {
    const partnerId = Number(payload?.partnerId) || null;
    const key = partnerId ?? 'all';

    counteragentsLatestKey = key;

    if (counteragentsInFlight.has(key)) return counteragentsInFlight.get(key);

    const request = getCounteragents(partnerId ? { partnerId } : {})
      .then((response) => {
        if (key !== counteragentsLatestKey) return;

        if ('success' in response.data && response.data.success) {
          commit('UPDATE_COUNTERAGENTS', response.data.data);
          commit('privilege/UPDATE_COUNTERAGENT_PRIVILEGE', response.data.privilege, { root: true });
          commit('COUNTERAGENTS_DATA_IS_UPDATED', false);
        }
      })
      .catch(() => {
        if (key !== counteragentsLatestKey) return;

        commit('privilege/UPDATE_COUNTERAGENT_PRIVILEGE', getDenyPrivilegeObject(), { root: true });
      })
      .finally(() => {
        counteragentsInFlight.delete(key);
      });

    counteragentsInFlight.set(key, request);

    return request;
  },

  createCounteragent({ commit }, params) {
    return createCounteragent(params)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          ElNotification.success({
            message: response.data.message,
            duration: 2000,
          });

          commit('COUNTERAGENTS_DATA_IS_UPDATED', true);

          return response.data.data?.id ?? null;
        }

        return null;
      })
      .catch((error) => {
        ElNotification.error({
          dangerouslyUseHTMLString: true,
          message: getErrorMessage(error?.response?.data),
          duration: 2000,
        });

        return null;
      });
  },

  updateCounteragent({ commit }, { id, data }) {
    return updateCounteragent(id, data)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          ElNotification.success({
            message: response.data.message,
            duration: 2000,
          });

          commit('COUNTERAGENTS_DATA_IS_UPDATED', true);

          return id;
        }

        return null;
      })
      .catch((error) => {
        ElNotification.error({
          dangerouslyUseHTMLString: true,
          message: getErrorMessage(error?.response?.data),
          duration: 2000,
        });

        return null;
      });
  },

  deleteCounteragent({ commit }, id) {
    deleteCounteragent(id)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          ElNotification.success({
            message: response.data.message,
            duration: 2000,
          });

          commit('COUNTERAGENTS_DATA_IS_UPDATED', true);
        }
      })
      .catch((error) => {
        ElNotification.error({
          dangerouslyUseHTMLString: true,
          message: getErrorMessage(error?.response?.data),
          duration: 2000,
        });
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
